import React, { useEffect } from "react";
import './PublicTestList.scss';
import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

// function PublicTestList (props){

//     return (
//         <div className="container">
//             <div className="title-container">
//                 <LeftOutlined className="left-outlined-icon"/>
//                 <span className="title text-2xl font-bold">
//                     Tests
//                 </span>
//             </div>
//         </div>
//     );
// }

export default function Component() {

  // const location = useLocation();
  // const {testsList} = location.state;
  const testsList = JSON.parse(localStorage.getItem('testsList'))
  const navigate = useNavigate();
  const location = useLocation();
  const  mode = 'test';

  useEffect(() => {
    const isG1 = localStorage.getItem('isG1') || JSON.parse(localStorage.getItem('isG1'));


    return (()=>{
      localStorage.removeItem('isG1')
    })
  }, [])

  const handleTestClick = (i) => {
    navigate('/quiz', {
      state: {
        mode: mode,
        questionIdList: testsList[i].content,
        attemp: testsList[i].attemp,
        quiz_id: testsList[i].quiz_id,
        backPath: '/public-test-list',
        testsListIndex: i,
      }
    })
  }

  return (
    <div className="bg-white p-4">
      <div className="flex items-center justify-between">
        <LeftOutlined onClick={() => { navigate('/public-quiz') }} className="text-gray-600" style={{ fontSize: '22px' }} />
        <h1 className="text-xl font-semibold">Tests</h1>
        <div className="flex items-center space-x-2" style={{ width: '22px' }}>
        </div>
      </div>
      <div className="mt-4 space-y-3">
        {testsList.map((ele, index) => <div key={index} className="flex items-center p-4 rounded-lg bg-gray-100" onClick={() => handleTestClick(index)}>
          <ListIcon className="text-blue-500" />
          <span className="ml-3 text-lg font-medium">Practice Test {index + 1}</span>
        </div>
        )}
        {/* <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <ListIcon className="text-blue-500" />
            <span className="ml-3 text-lg font-medium">Practice Test 1</span>
          </div>
          <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <ListIcon className="text-blue-500" />
            <span className="ml-3 text-lg font-medium">Practice Test 2</span>
          </div>
          <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <ListIcon className="text-blue-500" />
            <span className="ml-3 text-lg font-medium">Practice Test 3</span>
          </div>
          <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <ListIcon className="text-blue-500" />
            <span className="ml-3 text-lg font-medium">Practice Test 4</span>
          </div>
          <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <ListIcon className="text-blue-500" />
            <span className="ml-3 text-lg font-medium">Practice Test 5</span>
          </div>
          <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <ListIcon className="text-blue-500" />
            <span className="ml-3 text-lg font-medium">Practice Test 6</span>
          </div>
          <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <CheckIcon className="text-green-500" />
            <CrossIcon className="text-red-500" />
            <span className="ml-3 text-lg font-medium">Road Rules Test</span>
          </div>
          <div className="flex items-center p-4 rounded-lg bg-gray-100">
            <ListIcon className="text-blue-500" />
            <span className="ml-3 text-lg font-medium">Fines and Points</span>
          </div> */}
      </div>
    </div>
  )
}



function CheckIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}


function ClockIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  )
}


function CrossIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z" />
    </svg>
  )
}


function ListIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="8" x2="21" y1="6" y2="6" />
      <line x1="8" x2="21" y1="12" y2="12" />
      <line x1="8" x2="21" y1="18" y2="18" />
      <line x1="3" x2="3.01" y1="6" y2="6" />
      <line x1="3" x2="3.01" y1="12" y2="12" />
      <line x1="3" x2="3.01" y1="18" y2="18" />
    </svg>
  )
}